module.exports = __webpack_public_path__ + "static/img/banner_3.5e0cf721.png";